import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaginatorComponent } from './paginator.component';
import { IconModule } from 'src/app/components/icon/icon.module';
import { ButtonModule } from '../button/button.module';

@NgModule({
  declarations: [PaginatorComponent],
  exports: [PaginatorComponent],
  imports: [CommonModule, ButtonModule, IconModule],
})
export class PaginatorModule {}
